var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "appointment-time-selector"
  }, [_c('h2', {
    staticClass: "title-with-underline"
  }, [_vm._v("請選擇就診時間")]), _c('div', {
    staticClass: "date-selection"
  }, _vm._l(_vm.paginatedDates, function (day, index) {
    return _c('div', {
      key: index,
      staticClass: "appointment-day"
    }, [_c('h4', {
      staticClass: "date-title"
    }, [_vm._v(_vm._s(day.date) + " (" + _vm._s(_vm.getWeekday(day.date)) + ")")]), _c('div', {
      staticClass: "time-slots-container"
    }, _vm._l(_vm.transformSlots(day.timeSlots, day.date), function (item, index) {
      return _c('button', {
        key: index,
        staticClass: "time-slot",
        class: {
          full: item.isFull,
          unavailable: item.isUnavailable,
          selected: item.value === _vm.value && !item.isUnavailable && !item.isFull
        },
        attrs: {
          "disabled": item.isUnavailable || item.isFull
        },
        on: {
          "click": function click($event) {
            return _vm.handleSelectionChange(item.value);
          }
        }
      }, [_vm._v(" " + _vm._s(item.label) + " " + _vm._s(item.description) + " ")]);
    }), 0)]);
  }), 0), _c('div', {
    staticClass: "show-more-dates",
    class: {
      'disabled': !_vm.hasMoreDates
    },
    on: {
      "click": _vm.loadNextPage
    }
  }, [_vm._v("顯示更多時段")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }